import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, GraduationCap, Search, Users, User } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function BottomNav() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const items = [
    { path: '/', icon: Home, label: 'Home', testId: 'bottomnav-home', requiresAuth: false },
    { path: '/learn', icon: GraduationCap, label: 'Learn', testId: 'bottomnav-learn', requiresAuth: false },
    { path: '/search', icon: Search, label: 'Search', testId: 'bottomnav-search', requiresAuth: false },
    { path: '/community', icon: Users, label: 'Community', testId: 'bottomnav-community', requiresAuth: true },
    { path: '/profile', icon: User, label: 'Profile', testId: 'bottomnav-profile', requiresAuth: true },
  ];

  const visibleItems = items.filter(item => !item.requiresAuth || isAuthenticated);

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-t border-[#E7E5E4]" data-testid="bottom-navigation"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <div className="flex items-center justify-around h-14 px-1">
        {visibleItems.map(({ path, icon: Icon, label, testId }) => (
          <Link key={path} to={path}
            className={`flex flex-col items-center justify-center gap-0.5 min-w-[56px] py-1.5 rounded-xl transition-colors ${
              isActive(path) ? 'text-[#4CAF50]' : 'text-[#A8A29E]'
            }`}
            data-testid={testId}
          >
            <Icon className={`w-5 h-5 ${isActive(path) ? 'stroke-[2.5]' : ''}`} />
            <span className="text-[10px] font-medium leading-none">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
